<template>
    <div class="devprofile container-fluid">
        <Navbar />
        <div class=" mt-5">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-9 px-md-5 bg-light">
                    <Profile />
                </div>
                <div class="col-sm-12 col-md-12 col-lg-3 bg-light pt-5">
                    <h4 class="font-weight-bold text-capitalize mt-4">connect with talents</h4>
                    <form class="pb-4 m-auto cont-w">                  
                        <input type="email" class="w-75 my-3 mx-auto form-control input-height" id="email" placeholder="Company's email address" />                      
                        <input type="password" class="w-75 my-3 mx-auto form-control input-height" id="pwd" placeholder="Password" />                     
                        <input type="password" class="w-75 my-3 mx-auto form-control input-height" id="email" placeholder="Confirm Password" />
                        <br />
                        <div class="m-auto">
                            <router-link to="/hire">
                            <button class="btn btn-kovatek submit-w mb-4">Register</button>
                            </router-link>
                            <p>Already have an account? <router-link to="/login">Login</router-link> </p>
                        </div>
                    </form>
                </div>  
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Profile from '@/components/Profile.vue';
export default {
    name: 'devprofile',
    components: {
        Profile, Navbar, Footer
    }
}
</script>

<style scoped>

.btn-kovatek{
  background-color: #20409A;
  height: 50px;
  color: #fff;
  transition: .25s;
}
.btn-kovatek:hover{
  background-color: #06216d;
  color: #fff;
}
.input-height{
    height: 50px;
    font-size: 13px;
    width: 100%;
}
.submit-w{
    width: 300px;
}   
@media screen and (min-width: 992px) and (max-width: 1325px){
.cont-size{
    width: 600px;
}
}

@media screen and (min-width: 768px) and (max-width: 991px){
.cont-size{
    width: 600px;
}
}

@media screen and (max-width: 767px){
    .cont-size{
    width: 500px;
}
}

@media screen and (max-width: 450px){
    .cont-size{
    width: 100%;
}
}
</style>  